module.exports = __webpack_public_path__ + "static/media/dev-hero.1593aed2.jpg";